import { lazyWithRetry } from "@/router/lazyWithRetry";
import { RouteConfig } from "@/router/types";

const Login = lazyWithRetry(() => import("@/pages/auth/login"));
const MicrosoftCallback = lazyWithRetry(
  () => import("@/pages/auth/microsoftCallback"),
);
const ForgotPassword = lazyWithRetry(
  () => import("@/pages/auth/forgotPassword"),
);
const ResetPassword = lazyWithRetry(() => import("@/pages/auth/resetPassword"));
const Unauthorized = lazyWithRetry(() => import("@/pages/Unauthorized"));
const FieldMappingHarness = lazyWithRetry(
  () => import("@/pages/test/FieldMappingHarness"),
);

const PagesRoutes: RouteConfig[] = [
  {
    path: "/login",
    component: Login,
    public: true,
  },
  {
    path: "/auth/microsoft-callback",
    component: MicrosoftCallback,
    public: true,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    public: true,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    public: true,
  },
  {
    path: "/unauthorized",
    component: Unauthorized,
  },
  {
    path: "/test/field-mapping",
    component: FieldMappingHarness,
    public: true,
  },
];

export default PagesRoutes;
